import Vue from 'vue'
import App from './App.vue'
import router from './routes/index.js';
import store from './store/index.js';
import Plugin from '@/utils/plugins';

Vue.config.productionTip = false
Plugin.install()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
